<template>
  <div>
    <vue-form-generator :schema="schema" :model="model" ref="initForm" :options="formOptions"></vue-form-generator>
    <b-button variant="success" @click="save()" v-if="init && Object.keys(this.init).length !== 0">Сохранить</b-button>
    <b-button variant="success" @click="create()" v-else>Добавить</b-button>
  </div>
</template>

<script>
import VueFormGenerator from "vue-form-generator";
import "vue-form-generator/dist/vfg.css";
export default {
  name: "newInit",
  props: {
    outflows: Array,
    init: Object,
    object: Object,
  },
  watch: {
    outflows: function (val) {
      this.schema.groups[0].fields[0].values = val;
    },
  },
  created() {
    if (this.init && Object.keys(this.init).length !== 0) {
      this.$set(this, "model", JSON.parse(JSON.stringify(this.init)));
    } else {
      Object.assign(this.$data, this.$options.data.call(this));
    }
    this.$set(this.schema.groups[0].fields[0], "values", this.outflows);
  },
  data() {
    return {
      model: {
        id: null,
        outflow_type: 1,
        C: null,
        diameter: 5,
        P: 1,
        validator: {},
      },
      schema: {
        groups: [
          {
            fields: [
              {
                type: "select",
                inputType: "text",
                label: "Событие",
                model: "outflow_type",
                required: true,
                values: [],
                selectOptions: {
                  hideNoneSelectedText: true,
                },
                validator(value, field, model) {
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
                disabled: function (model) {
                  return model.id ? true : false;
                },
              },
              {
                type: "input",
                inputType: "text",
                label: "Наименование события",
                model: "C",
                required: true,
                validator(value, field, model) {
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
              {
                type: "input",
                inputType: "number",
                label: "Диаметр, мм",
                model: "diameter",
                required: true,
                visible: function (model) {
                  return model.outflow_type == 1 ||
                    model.outflow_type == 5 ||
                    model.outflow_type == 6 ||
                    model.outflow_type == 7
                    ? true
                    : false;
                },
                validator(value, field, model) {
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
              {
                type: "select",
                inputType: "select",
                label: "Частота возникновения события",
                model: "auto_calc",
                required: true,
                selectOptions: {
                  hideNoneSelectedText: true,
                },
                values: [
                  { id: "manual", name: "Задать вручную" },
                  {
                    id: "pipeline",
                    name: "Вероятность от диаметра отверстия в технологическом трубопроводе (Таблица П1.2)",
                  },
                  { id: "hole", name: "Вероятность образования прокола (для магистральных трубопроводов)" },
                  { id: "crack", name: "Вероятность образования трещины (для магистральных трубопроводов)" },
                  { id: "break", name: "Вероятность разрыва (для магистральных трубопроводов)" },
                ],
                validator(value, field, model) {
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
                visible: function () {
                  if (
                    this.$parent.$parent.$parent.$parent.object.obj_type == 61 ||
                    this.$parent.$parent.$parent.$parent.object.obj_type == 62 ||
                    this.$parent.$parent.$parent.$parent.object.obj_type == 23 ||
                    this.$parent.$parent.$parent.$parent.object.obj_type == 22 ||
                    this.$parent.$parent.$parent.$parent.object.obj_type == 23 ||
                    this.$parent.$parent.$parent.$parent.object.obj_type == 41 ||
                    this.$parent.$parent.$parent.$parent.object.obj_type == 42 ||
                    this.$parent.$parent.$parent.$parent.object.obj_type == 43 ||
                    this.$parent.$parent.$parent.$parent.object.obj_type == 44 ||
                    this.$parent.$parent.$parent.$parent.object.obj_type == 45 ||
                    this.$parent.$parent.$parent.$parent.object.obj_type == 46
                  ) {
                    return true;
                  } else {
                    return false;
                  }
                },
              },
              {
                type: "input",
                inputType: "number",
                label: "Частота возникновения события, год-1",
                model: "P",
                required: true,
                validator(value, field, model) {
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
                visible: function (model) {
                  //visible if business is selected1 5 6 7 8 9
                  if (!model.auto_calc || model.auto_calc == "manual") {
                    return true;
                  } else {
                    return false;
                  }
                },
              },
            ],
          },
        ],
      },
      formOptions: {
        validateAfterLoad: true,
        validateAfterChanged: true,
        validateAsync: true,
      },
    };
  },
  components: {
    "vue-form-generator": VueFormGenerator.component,
  },
  methods: {
    showWindow(init, index) {
      this.model = Object.assign(this.model, { index: index }, init);
      this.$refs.newInit.show();
    },
    create() {
      this.$http
        .post("risk/tree/init-add?id=" + this.object.id + "&obj_type=" + this.object.obj_type, this.model)
        .then((response) => {
          this.$emit("initPush", response.data);
          this.$set(this.model, "validator", {});

          this.$emit("hideActionWindow");
        })
        .catch((e) => {
          this.$set(this.model, "validator", {});
          this.$set(this.model, "validator", e.response.data);
          this.$refs.initForm.validate();
        });
    },
    save() {
      this.$http
        .post("risk/tree/init-update?id=" + this.model.id + "&obj_type=" + this.object.obj_type, this.model)
        .then((response) => {
          this.$emit("initUpdate", response.data);
          this.$set(this.model, "validator", {});

          this.$emit("hideActionWindow");
        })
        .catch((e) => {
          this.$set(this.model, "validator", {});
          this.$set(this.model, "validator", e.response.data);
          this.$refs.initForm.validate();
        });
    },
  },
};
</script>
